import Vue from "vue";
import App from "./App.vue";

import store from "./store";

import "./registerServiceWorker";

import vuetify from "./plugins/vuetify";
//import "./plugins/draggable";
import "./plugins/touch";

//import firebasePlugin from "./plugins/firebase";
import firebase from "firebase";
import router from "./router";

import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "animate.css/animate.min.css";
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';



Vue.config.productionTip = false;


//Vue.use(firebasePlugin);

firebase.auth().onAuthStateChanged(() =>
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app")
);
